import { Component, forwardRef, Input, Provider } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QaCheckResult } from 'chronos-core-client';

const VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => QaCheckSelectButtonComponent),
  multi: true
};

@Component({
  selector: 'app-qa-check-select-button',
  templateUrl: './qa-check-select-button.component.html',
  styleUrls: ['./qa-check-select-button.component.scss'],
  providers: [VALUE_ACCESSOR]
})
export class QaCheckSelectButtonComponent implements ControlValueAccessor {
  @Input() public name: string;
  @Input() public disabled = false;

  public value: any;

  private readonly RESULT_SELECT_BUTTON_STYLES_DEFAULT: { [isDisabled: string]: string } = {
    'true': 'result-select-button__item--disabled',
    'false': 'result-select-button__item--inactive'
  };

  private readonly RESULT_SELECT_BUTTON_STYLES: { [result: string]: { [isDisabled: string]: string } } = {
    [QaCheckResult.Ok]: {
      'true': 'result-select-button__item--ok--disabled',
      'false': 'result-select-button__item--ok--active'
    },
    [QaCheckResult.NotOk]: {
      'true': 'result-select-button__item--nok--disabled',
      'false': 'result-select-button__item--nok--active'
    },
    [QaCheckResult.WarningOk]: {
      'true': 'result-select-button__item--wok--disabled',
      'false': 'result-select-button__item--wok--active'
    },
    [QaCheckResult.NotApplicable]: {
      'true': 'result-select-button__item--na--disabled',
      'false': 'result-select-button__item--na--active'
    }
  };

  public readonly RESULT_VALUES: { label: string; value: QaCheckResult }[] = [
    { label: 'Ok', value: QaCheckResult.Ok },
    { label: 'Nok', value: QaCheckResult.NotOk },
    { label: 'Wok', value: QaCheckResult.WarningOk },
    { label: 'Na', value: QaCheckResult.NotApplicable }
  ];

  private onChange: (result: string) => void;
  private onTouched: () => void;

  public writeValue(value: any): void {
    this.setControlValue(value);
  }

  public setValue(value: string): void {
    if (this.disabled) {
      return;
    }

    this.setControlValue(value);
    this.onChange(value);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public getResultSelectButtonStyle(resultValue: string, isDisabled: boolean): string {
    if (resultValue === this.value) {
      return this.RESULT_SELECT_BUTTON_STYLES[resultValue][isDisabled.toString()];
    } else {
      return this.RESULT_SELECT_BUTTON_STYLES_DEFAULT[isDisabled.toString()];
    }
  }

  private setControlValue(value: string): void {
    this.value = value;
  }
}
